import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  rangeContainer: {
    backgroundColor: theme.palette.black.lighter,
    '& .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.white.main,
    },
    '&.DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.white.main,
    },
    '& .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside)': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.white.main,
    },
    '& .DayPicker-Day': {
      borderRadius: '0 !important',
    },
    '& .DayPicker-Day--today': {
      color: theme.palette.secondary.main,
    },
  },

  calendarIcon: {
    color: theme.palette.gray.main,
  },
}));
